module.exports = __webpack_public_path__ + "media/audio21.70fc0141.wav";